import {Box, Typography} from "@mui/material"
import React from "react"
import {AppButton} from "@app-core/AppButton"
import {NAVY} from "theme"

interface EligibilityWelcomeMsgProps {
  onNext: () => void
}

// Screen 5: Eligibility Overview. Rewritten per the brief — no illustration,
// no inner bordered box, no "click here" / Life-Sustaining Therapy popup modal.
export const EligibilityWelcomeMsg: React.FC<EligibilityWelcomeMsgProps> = (
  props: EligibilityWelcomeMsgProps
) => {
  const {onNext} = props

  return (
    <Box padding={{xs: 3, sm: 6}}>
      <Typography
        component="h1"
        fontWeight="bold"
        fontSize={{xs: "24px", sm: "28px"}}
        color={NAVY}
        marginBottom={3}
      >
        Find out if you may qualify for the Disability Tax Credit.
      </Typography>

      <Typography
        fontSize="18px"
        color={NAVY}
        lineHeight={1.6}
        marginBottom={2}
      >
        This check will walk you through questions about the following areas of
        daily living:
      </Typography>

      <Typography
        fontSize="18px"
        fontWeight="bold"
        color={NAVY}
        lineHeight={1.6}
        marginBottom={2}
      >
        Seeing. Talking. Hearing. Walking. Using the Bathroom. Eating or
        Preparing a Meal. Getting Dressed. Performing Mental Tasks.
      </Typography>

      <Typography
        fontSize="18px"
        color={NAVY}
        lineHeight={1.6}
        marginBottom={2}
      >
        You may also qualify if you experience difficulty in more than one of
        these areas combined. If you require therapy to support a vital
        function, you may qualify under Life-Sustaining Therapy.
      </Typography>

      <Typography fontSize="18px" color={NAVY} lineHeight={1.6}>
        Your impairment must affect you all or almost all of the time, even with
        medication, therapy, or assistive devices, and must have lasted or be
        expected to last at least one year.
      </Typography>

      <Box display="flex" justifyContent="flex-end" marginTop={4}>
        <AppButton onClick={onNext} sx={{minWidth: "150px"}}>
          Next
        </AppButton>
      </Box>
    </Box>
  )
}

export default EligibilityWelcomeMsg
